import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chits-reports',
  templateUrl: './chits-reports.component.html',
  styleUrls: ['./chits-reports.component.css']
})
export class ChitsReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/chits-reports/chits-reports.component.ts